import { render, staticRenderFns } from "./stock-addition-payments.vue?vue&type=template&id=5ce85360"
import script from "./stock-addition-payments.vue?vue&type=script&lang=js"
export * from "./stock-addition-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports